// Hint: The string values should match the titles used in SidebarConfiguration
export const SIDEBAR_AREA = {
  summary: 'Summary',
  auditLog: 'Audit Log',
  edit: 'Edit',
  link: 'Link',
  translations: 'Translations',
  detailedTranslations: 'State of Translations',
  languageConfiguration: 'Language Configuration',
  review: 'Review',
  mergeReview: 'Merge Review',
};
